import React from "react";
import "../styles/Staffing.css";

function Staffing() {
  return (
    <div className="background">
      <div className="container">
        <div className="staffing-intro">
          <h1>
            Confidently Manage Payroll with <br /> Staffing Invoice Factoring
          </h1>
          <div className="staffing-row">
            <p className="basic-text-first-part">
              Staffing invoice factoring provides immediate funding to support
              payroll, operations, and growth. Trana’s staffing solutions help
              agencies—from temporary staffing firms to recruitment
              companies—access up to 98% of their invoice value quickly,
              eliminating cash flow gaps caused by slow-paying clients.
            </p>

            <div className="staffing-image">
              <img src="/staffing.png" alt="staffing" />
            </div>
          </div>

          <p className="basic-text second-part">
            Balancing timely payroll with extended client payment terms can be
            challenging. Staffing invoice factoring bridges this gap, ensuring
            employees are paid on time while maintaining consistent cash flow.
            Strengthen your financial stability and focus on growing your
            business without payroll disruptions.
          </p>
        </div>
        <div className="staffing-wait">
          <div className="h2-styling">
            <h2>Your Staff Can’t Wait—Why Should You?</h2>
          </div>
          <p className="basic-text">
            Keep payroll running without delays. Invoice factoring gives you
            fast access to cash so your team gets paid on time, every time.
            Trana understands the impact of slow-paying clients and provides
            staffing solutions that keep your business moving. Get up to 97% of
            your invoice value—right when you need it.
          </p>
        </div>
        <div className="staffing-customized">
          <div className="h2-styling">
            <h2>Customized Support for Staffing Agencies</h2>
          </div>
          <p className="basic-text">
            Sectors such as healthcare, IT, manufacturing, and hospitality
            depend on staffing firms to keep up with changing workforce demands.
            Trana provides tailored solutions designed specifically for staffing
            companies, including options that help manage recruitment-related
            invoices and temporary staffing bills. We help ensure you have
            steady cash flow to pay workers, handle administrative expenses, and
            pursue new opportunities — keeping your agency strong and adaptable
            in any market.
          </p>
          <div className="cards">
            <div className="cardStyle">
              <div className="cardText">
                <h3>Meet Weekly Payroll Without Stress</h3>
                <p>
                  Managing a team is challenging enough without worrying about
                  whether payroll will be covered. Staffing‑focused support
                  removes the uncertainty of waiting on client payments or
                  overdue invoices. Trana provides quick access to the funds you
                  need so you can handle payroll every week with confidence
                </p>
              </div>
            </div>
            <div className="cardStyle">
              <div className="cardText">
                <h3>Gain Greater Financial Flexibility</h3>
                <p>
                  Staffing‑related invoice support helps free up the working
                  capital tied to unpaid client bills. By turning your
                  outstanding receivables into readily available funds, you gain
                  more flexibility to manage day‑to‑day operations and keep your
                  business running smoothly
                </p>
              </div>
            </div>
            <div className="cardStyle">
              <div className="cardText">
                <h3>Pursue Exciting Growth Opportunities</h3>
                <p>
                  Consistent cash flow is the foundation of business expansion.
                  Staffing‑related invoice support helps you move forward with
                  new opportunities, making it easier to broaden your services,
                  take on larger clients, and invest in the long‑term growth of
                  your company
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Staffing;
